import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container router-view" }

import { Modal } from "ant-design-vue";
import Header from "@/components/Header/index.vue";
import FloatTip from "@/components/FloatTip/index.vue";
import CopyrightFooter from "@/components/CopyrightFooter/index.vue";
import QueueControl from "@/components/QueueControl/index.vue";
import ExitControl from "@/components/Control/ExitControl.vue";
import FloatingControl from "@/components/Control/FloatingControl.vue";
import BuyGoodModal from "@/components/BuyGoodModal/index.vue";
import PurchasedGameModal from "@/components/PurchasedGameModal/index.vue";
import LowerBrowserInfo from "@/components/LowerBrowserInfo/index.vue";
import webVersionUpdateModal from "@/components/webVersionUpdateModal/index.vue";

import { usePlayGameStore } from "@/store/playGame";
import { useloginStore } from "@/store/login";
import IPCCenter from "@/js/ipc";
import { EVENTCMD } from "@/js/events";
import { onMounted } from "vue";
import DYLongLinkClient from "@/js/web/socket/websocket";
import { setCurrentGame } from "@/js/account/index";
import CheckGameingWindow from "@/js/checkGameingWindow";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const playGameStore = usePlayGameStore();
const loginStore = useloginStore();

const handleGameExit = () => {
  playGameStore.$patch((state) => {
    state.floatModal = false;
    state.queueModal = false;
  });
  playGameStore.handleGameExit();
};
// 跨页面通信监听
const bindIPCEvent = () => {
  // 挂机检测
  IPCCenter.getInstance().addListener(EVENTCMD.AfterExitGame, (evt: any) => {
    console.log("接收到退出游戏", evt);
    evt.isMyself || playGameStore.resetModalState();
  });
  // 退出登录
  IPCCenter.getInstance().addListener(EVENTCMD.Logout, (evt: any) => {
    playGameStore.resetModalState();
    Modal.destroyAll();
    handleGameExit();
    setCurrentGame(null);
    DYLongLinkClient.getInstance().disconnect();

    if (!evt.isMyself) {
      window.location.reload();
    }
  });
  // 检测gameWindow页面是否存在
  IPCCenter.getInstance().addListener(EVENTCMD.echoGameWidnowExist, () => {
    CheckGameingWindow.waitingEchoExistGameWindow = false;
  });
};
onMounted(() => {
  bindIPCEvent();
  loginStore.setup();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { "bg-color": "rgba(17, 17, 17, 1)" }),
    _createVNode(FloatTip),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(CopyrightFooter),
    _createVNode(QueueControl),
    _createVNode(ExitControl),
    _createVNode(FloatingControl),
    _createVNode(BuyGoodModal),
    _createVNode(LowerBrowserInfo),
    _createVNode(PurchasedGameModal),
    _createVNode(webVersionUpdateModal)
  ], 64))
}
}

})